// crop.interface.ts
export enum CropType {
  BLE,
  COLZA,
  ORGE,
}

export interface CropData {
  commandes: {
    total: {
      barChart: any;
      doughnutChart: any;
    };
    doughnutCharts: {
      [key: string]: any;
    };
  };
  conseils: {
    gaugeCharts?: any[];
    groupedBarCharts: {
      [title: string]: {
        labels: string[];
        datasets: { label: string; data: number[]; backgroundColor: string }[];
      };
    };
  };
}
export interface DashboardTab {
  type: CropType;
  label: string;
  data: CropData;
}

export function ensureCropData(tab: DashboardTab): CropData {
  if (!tab.data) {
    tab.data = {
      commandes: {
        total: {
          barChart: null,
          doughnutChart: null,
        },
        doughnutCharts: {},
      },
      conseils: {
        gaugeCharts: [] as GaugeChartModel[],
        groupedBarCharts: {} as {
          [title: string]: {
            labels: string[];
            datasets: { label: string; data: number[]; backgroundColor: string }[];
          };
        },
      },
    };
  }
  return tab.data;
}

export interface GaugeChartModel {
  title: string;
  progressPercentage: number;
  colorSegments?: string[];
  description: { color: string; text: string }[];
  descriptionPosition?: 'above' | 'left' | 'none';
  bottomLeftLabel?: string;
  bottomRightLabel?: string;
}
